import Chip, { type ChipProps } from "@mui/material/Chip";
import { useTypedSelector } from "hooks";
import { find } from "util/support";
import { selectBankingSdkRecipientPostalAddressTypeOptions } from "features/general/selectors";
import When from "ui/support/When";
import withGridCellParams from "./withGridCellParams";

const PostalAddressType = withGridCellParams<string>(({ value, colDef }) => {
    const postalAddressType = find(
        useTypedSelector(selectBankingSdkRecipientPostalAddressTypeOptions),
        'id'
    )(String(value));

    const getChipProps = (label: ChipProps['label']): ChipProps => ({
        label,
        size: 'small',
        color: 'success',
        ...colDef.props as ChipProps,
    });

    return (
        <When
            if={Boolean(postalAddressType)}
            then={() => (
                <Chip
                    {...getChipProps(postalAddressType!.name)}
                />
            )}
        >
            <Chip
                {...getChipProps(value)}
                color='error'
            />
        </When>
    );
});

export default PostalAddressType;
